import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        pushLocation(context, data) {
            return pushModel(context, 'locations', data)
        }
    }
}
